import { render, staticRenderFns } from "./MeetingDocumentsRepresentedRecipients.vue?vue&type=template&id=6e4c69bd&"
import script from "./MeetingDocumentsRepresentedRecipients.vue?vue&type=script&lang=js&"
export * from "./MeetingDocumentsRepresentedRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports